// components/Header.js
import React, { useState } from "react";
import ChainButton from "../ChainButton"; // keep your existing file
import "../App.css";

export default function Header({ network, onNetworkChange, isScrolled }) {
  const [isHovered, setIsHovered] = useState(false); //
  return (
    <header className={`app-header ${isScrolled ? "header-scrolled" : ""}`}>
      <div className="header-content">
        <div
          className="dashboard-header-left"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <span>246&nbsp;</span>
          <span className="cpl-text">
            {isHovered ? " Cross-Protocol-Loan" : " CPL"}
          </span>
        </div>
        <div className="header-right-area">
          <div className="club-div">0x246....club</div>
          <ChainButton
            selectedChain={network}
            onChainSelect={onNetworkChange}
          />
        </div>
      </div>
    </header>
  );
}
